import { DEFAULT_CURRENCY } from 'src/utils/currency';

import { useCompany } from './Company.store';

/** Re-exported so callers have one currency import. The constant is declared
 *  in the leaf `src/utils/currency` on purpose: declaring it here would make
 *  that formatting util import the company store and close a module cycle. */
export { DEFAULT_CURRENCY };

/**
 * Normalizes the company payload's `currency` to an uppercase ISO 4217 code,
 * falling back to DKK when the backend does not send one.
 */
export const getCompanyCurrency = (currency?: string | null): string => {
  const trimmed = currency?.trim();
  return trimmed ? trimmed.toUpperCase() : DEFAULT_CURRENCY;
};

/** The tenant's configured currency code, e.g. 'EUR' for HSY. */
export const useCompanyCurrency = (): string => {
  const { data } = useCompany();
  return getCompanyCurrency(data?.currency);
};
